module.exports = __webpack_public_path__ + "static/media/login22.67f79279.png";